
export default {

    setList(state, list) {
        state.list = list;
    },
    setOrder(state, order) {
        state.order = order;
    },
}